import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { polarisProjectLayout } from '@jira/platform__layouts-polaris-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { polarisIdeasRoute } from '@jira/router-routes__polaris-routes/src/polarisIdeasRoute.tsx';
import { ideasPageEntryPoint } from './ui/ideas/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const polarisIdeasRouteEntry: Route = createEntry(polarisIdeasRoute, () => ({
	isStrictModeEnabled: false,
	group: 'polaris',
	ufoName: 'jpd.project',
	layout: polarisProjectLayout,
	canTransitionIn: () => true,

	navigation: {
		menuId: MenuIdProjects,
	},

	resources: [
		...getNavigationResources(),
		// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
		// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
		incidentExperimentTraitResource,
		// eslint-disable-next-line jira/router/no-project-context-resource
		projectContextResource,
		forgeProjectModuleResource,
		staticProjectSidebarNavigationResource,
		staticProjectSidebarConnectAddonsNavigationResource,
		// end of resources expanded from getNavigationSidebarProjectResource
	],

	entryPoint() {
		return ideasPageEntryPoint;
	},

	preloadOptions: {
		earlyChunks: ['jpd-ideas-early-entry'],
	},

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
